<template>
  <div class="">
    <div class="iv-header">
      <section class="iv-main-width iv-p-t-40 iv-enroll-top iv-p-b-40">
        <Expand :defaultExpand="true">
          <h1 class="iv-fs-24 iv-fc-85" slot="title">{{questionnaire.questionnaireName}}</h1>
          <p class="iv-m-t-12 iv-fs-16 iv-fc-65">创建组织：{{questionnaire.createUnitName}}</p>
          <Row class="iv-m-t-12">
            <Col :span="8" class="iv-fs-16 iv-fc-65">创建人：{{questionnaire.createUserName}}</Col>
            <Col :span="8" class="iv-fs-16 iv-fc-65">问卷日期：{{timeFormat(questionnaire.beginDate) + '至' + timeFormat(questionnaire.endDate) }}</Col>
          </Row>
          <p class="iv-m-t-12 iv-fs-16 iv-fc-65">问卷说明：{{questionnaire.questionnaireExplain}}</p>
        </Expand>
      </section>
    </div>
    <div class="iv-content iv-p-t-40">
      <div class="iv-main-width iv-p-b-65">
        <section>
          <Expand :defaultExpand="true">
            <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-36" slot="title">题目序号</h1>
            <div style="overflow:hidden">
              <a v-for="(item, index) in qusetion.list"
              :key="item.questionId"
              @click="jump(item.questionId)"
              class="iv-list iv-pull-left iv-fs-16"
              :class="item.isAnswer ? 'iv-active' : ''"
              >{{index + 1}}</a>
            </div>
          </Expand>
        </section>
        <section>
          <div class="iv-qusetion-content iv-p-b-16 iv-p-t-8">
            <component v-for="(item, index) in qusetion.list" :key='index' @change="change" :index="index" :item="item" :is="qusetiontypeMap[item.questionType]"></component>
          </div>
        </section>
      </div>
      <FooterOperator>
        <div class="iv-text-center">
          <span v-if="printstate != 1">
            <Button v-if="state == 1" class="iv-m-r-8" type="save" @click="save">保存</Button>
            <!-- <Button class="iv-m-r-8" type="export" @click="print">导出</Button> -->
            <Button class="iv-m-r-8" type="print" @click="print">打印</Button>
            <Button v-if="state == 1" class="iv-m-r-8 iv-main-btn" type="submit" @click="submitPaoper">提交</Button>
          </span>
          <Button type="back" @click="back">返回</Button>
        </div>
      </FooterOperator>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
// import MainLayout from '@/page/business/main-layout-test'
import Single from './qusetiontype/single.vue'
import Multiple from './qusetiontype/multiple.vue'
import Expand from '@/components/expand-info'
import Score from './qusetiontype/score.vue'
import { timeFormat } from '@/utils'
import FooterOperator from '@/components/footer-operator'
export default {
  data () {
    return {
      //题型，1单选题，2多选题，3问答题，4表格题，5评价题
      qusetiontypeMap: {
        1: 'Single',
        2: 'Multiple',
        3: 'Shortanswer',
        4: 'Tableanswer',
        5: 'Score'
      },
      qusetion: {
        list: []
      },
      title: '',
      content: '',
      questionnaire: {},
      spinShow: false
    }
  },
  beforeUpdate () {
    // console.log('我变化了--index')
  },
  created () {
    this.config = {
      showHeader: 'true',
      ratio: '17/7'
    }
    this.id = this.$route.query.id
    if (!this.id) {
      this.$router.go(-1)
      return
    }
    this.state = this.$route.query.state
    this.printstate = this.$route.query.print
    this.getData()
  },
  watch: {
    'qusetion.list': function () {
      this.$nextTick(() => {
        if (this.printstate == 1) {
          setTimeout(function () {
            window.print()
          }, 200)
        }
      })
    }
  },
  methods: {
    timeFormat,
    print () {
      window.open(window.location.href + '&print=1')
    },
    jump (id) {
      let domHeight = this.getElementTop(document.getElementById(id))
      window.scrollTo(0, domHeight - 104)
    },
    getElementTop (el) {
      let actualTop = el.offsetTop
      let current = el.offsetParent
      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },
    change (param, index, isAnswer) {
      this.$set(this.qusetion.list[index], 'isAnswer', isAnswer)
    },
    getData () {
      let url = this.state == 1 ? 'api-uum/questionnaire/openQuestionnaire' : 'api-uum/questionnaire/viewPortalQuestion'
      // if (this.printstate == 1) {
      //   url = 'api-questionnaire/portal/questionnaire/preview/'
      // }
      this.$ajax({
        url: url,
        method: 'GET',
        data: {
          questionnaireID: this.id,
          id: this.id
        }
      }).then((res) => {
        this.qusetion.list = res.data.data.questionList
        this.questionnaire = res.data.data
        for (let item of this.qusetion.list) {
          if (item.questionType == 2 && !item.userOptions) {
            item.userOptions = []
          } else if (item.questionType == 1 && !item.userOptions) {
            item.userOptions = ['']
          }
        }
        //如果为打印则调用打印机
      })
    },
    save () {
      this.spinShow = true
      let data = this.getUserAnswer()
      // console.log(data, '答案是', JSON.stringify(data))
      if (!data.tempResultList.length) {
        delete data.tempResultList
      }
      this.$ajax({
        url: 'api-uum/questionnaire/savePortalQuestionnaire',
        method: 'POST',
        data: data
      }).then((res) => {
        this.$Message.success('保存成功')
        // console.log(res)
        this.spinShow = false
      }).catch(() => {
        this.$Message.error('保存失败')
        this.spinShow = false
      })
    },
    submitPaoper () {
      this.spinShow = true
      let data = this.getUserAnswer('submit')
      // 校验必填项
      let isRequireList = this.qusetion.list.filter(item => {
        return item.isRequire == 1
      })
      let isAnswer = isRequireList.every(item => {
        return item.isAnswer
      })
      if (isAnswer) {
        this.$ajax({
          url: 'api-uum/questionnaire/submitQuestionnaire',
          method: 'POST',
          data: data
        }).then((res) => {
          this.spinShow = false
          this.$Message.error('交卷成功')
          this.back()
        }).catch(() => {
          this.$Message.error('交卷失败')
          this.spinShow = false
        })
      } else {
        this.spinShow = false
        this.$Message.error('您有必填项未填写')
      }
    },
    getUserAnswer (type) {
      let data = {}
      data.tempResultList = []
      data.questionnaireID = this.id
      for (let item of this.qusetion.list) {
        if (item.questionType == 1) {
          //题型，1单选题，2多选题，3问答题，4表格题
          //单选题
          for (let i of item.optionList) {
            if (i.optionOrder == item.userOptions) {
              data.tempResultList.push({
                userOption: item.userOptions,
                userAnswer: i.userAnswer || '',
                questionID: item.questionId,
                questionType: 1
              })
            }
          }
        } else if (item.questionType == 2 && item.userOptions) {
          for (let q of item.userOptions) {
            for (let i of item.optionList) {
              if (q == i.optionOrder) {
                data.tempResultList.push({
                  userOption: q,
                  userAnswer: i.userAnswer || '',
                  questionID: item.questionId,
                  questionType: 2
                })
              }
            }
          }
        } else if (item.questionType == 3) {
          if (item.optionList.length > 0) {
            for (let i of item.optionList) {
              if (i.userAnswer) {
                data.tempResultList.push({
                  userOption: i.optionOrder,
                  userAnswer: i.userAnswer || '',
                  questionID: item.questionId,
                  questionType: 3
                })
              }
            }
          } else {
            if (item.userAnswer) {
              data.tempResultList.push({
                userAnswer: item.userAnswer || '',
                questionID: item.questionId,
                questionType: 3
              })
            }
          }
        } else if (item.questionType == 4) {
          let k = 0
          for (let i in item.vueQusetion) {
            // console.log(item.questionMap, i + 1, 'vueQusetion')
            let rowsCount = item.questionRows.split('[questiontable]').length
            if (item.questionMap[i - 0 + 1].slice(item.rowsNum + 1).toString().replace(/,/g, '').trim() == '' && (i - 0 + 1) > rowsCount) {
              continue
            }
            k++
            if ((i - 0 + 1) > rowsCount) {
              item.questionMap[i - 0 + 1][0] = k
            }
            data.tempResultList.push({
              userOption: item.questionMap[i - 0 + 1][0],
              userAnswers: item.questionMap[i - 0 + 1].slice(item.rowsNum + 1),
              questionID: item.questionId,
              questionType: 4
            })
          }
        } else if (item.questionType == 5) {
          let checkVal = item.checkVal + 1
          for (let i of item.optionList) {
            if (i.optionInfo == checkVal) {
              data.tempResultList.push({
                userOption: [i.optionOrder],
                userAnswer: i.userAnswer || '',
                questionID: item.questionId,
                questionType: 5
              })
            }
          }
        }
      }
      if (type) {
        data.submitResultList = JSON.parse(JSON.stringify(data.tempResultList))
        delete data.tempResultList
      }
      return data
    },
    back () {
      // this.$router.go(-1)
      this.$router.push({
        name: 'questionnaireList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    }
  },
  components: {
    Score,
    Single,
    Multiple,
    Shortanswer: () => import('./qusetiontype/short-answer.vue'),
    Tableanswer: () => import('./qusetiontype/table.vue'),
    Expand,
    FooterOperator
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/base/variable.scss';
@page{
  margin:0
}
.iv-content{
  background: #fff;
  border-radius: 4px;
  height: 100%;;
  .iv-title{
    border-bottom: 1px solid rgba(0,0,0,0.09);
  }
  .iv-qusetion-content{
    white-space: normal;
    word-break: break-all;
  }
  margin-bottom: 24px;
}
.iv-list{
  width: 64px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 20px;
  border: 1px solid #D9D9D9;
  line-height: 40px!important;
  text-align: center;
  margin-right: 16px;
  color: #5A5A5A;
  cursor: pointer;
  &.iv-active, &:hover{
    color: $iv-main-hover-color !important;
    border-color: $iv-main-hover-color !important;
    font-weight: bold;
  }
}
// .iv-list:nth-child(5n) {
//   margin-right: 0;
// }
.iv-main-btn {
  background: $iv-main-color !important;
  border-color: $iv-main-color !important;
  color: #fff!important;
}
.iv-p-b-65 {
  padding-bottom: 65px;
}
</style>